import { render } from "./DeepSeekAnalysis.vue?vue&type=template&id=0966a3aa&scoped=true"
import script from "./DeepSeekAnalysis.vue?vue&type=script&lang=js"
export * from "./DeepSeekAnalysis.vue?vue&type=script&lang=js"

import "./DeepSeekAnalysis.vue?vue&type=style&index=0&id=0966a3aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0966a3aa"]])

export default __exports__